import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Home from "./pages/Home";
import Call from "./pages/Call";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Call />} />
        <Route path="/:id" element={<Call />} />
      </Routes>
    </Router>
  );
}

export default App;
